<template>
  <v-alert text color="primary" :icon="icon" class="pedido-processo-intro">
    <div class="font-weight-bold">{{ titulo }}</div>
    <div class="text-body-2 mt-1">{{ descricao }}</div>
  </v-alert>
</template>

<script>
export default {
  name: "PedidoProcessoIntroducao",
  props: {
    titulo: { type: String, required: true },
    descricao: { type: String, required: true },
    icon: { type: String, default: "mdi-clipboard-check-outline" },
  },
};
</script>

<style>
.pedido-processo-intro {
  border-radius: 14px !important;
  margin-bottom: 20px !important;
}

.pedido-processo {
  background: linear-gradient(180deg, #fafbff 0%, #ffffff 100%);
  border: 1px solid #e9ecef;
  border-radius: 16px;
  padding: 22px !important;
}

.pedido-processo > .v-card {
  background: transparent !important;
  box-shadow: none !important;
}

.pedido-processo__painel {
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 14px;
  margin-top: 12px;
  padding: 20px !important;
}

.pedido-processo__painel--resumo {
  background: linear-gradient(180deg, #f8f9ff 0%, #ffffff 100%);
}

.pedido-processo__painel .card-header-padding {
  padding: 0 0 16px !important;
}

.pedido-processo__painel h5 {
  color: #344767 !important;
  font-size: 1.15rem !important;
}

.pedido-processo__painel .text-body,
.pedido-processo__painel .text-sm {
  color: #7b809a !important;
}

.pedido-processo__painel .v-data-table {
  border: 1px solid #edf0f7;
  border-radius: 12px;
  overflow: hidden;
}

.pedido-processo__painel .v-data-table tbody tr {
  transition: background-color 0.18s ease;
}

.pedido-processo__painel .v-data-table tbody tr:hover {
  background: #f5f7ff !important;
}

.pedido-processo__painel--catalogo .v-data-table tbody tr {
  cursor: pointer;
}

.pedido-processo__painel .v-card__actions {
  padding: 16px 0 0;
}

.pedido-processo-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

.pedido-processo-dialog > .v-card,
.pedido-processo-dialog .v-card {
  border-radius: 16px !important;
}

.pedido-processo-dialog .v-card__title {
  color: #344767;
  font-weight: 700;
  line-height: 1.35;
  padding: 22px 24px 12px;
}

.pedido-processo-dialog .v-card__text {
  padding: 16px 24px;
}

.pedido-processo-dialog .v-card__actions {
  padding: 8px 24px 22px;
}

.pedido-processo-dialog .v-btn.btn-primary {
  color: #ffffff !important;
}

.pedido-processo-listagem .pedido-processo-intro {
  margin-left: 12px;
  margin-right: 12px;
}

@media (max-width: 960px) {
  .pedido-processo {
    padding: 16px !important;
  }

  .pedido-processo__painel {
    padding: 16px !important;
  }
}

@media (max-width: 600px) {
  .pedido-processo-dialog .v-card__actions {
    align-items: stretch;
    flex-direction: column-reverse;
  }

  .pedido-processo-dialog .v-card__actions .v-btn {
    margin: 4px 0 !important;
    width: 100%;
  }
}
</style>
